import { useParams } from "react-router-dom";
import CaseStudy from "./CaseStudy";
import caseStudiesRevenueGrowth from "../../../const/caseStudiesData";
import { caseStudiesOperational, caseStudiesCustomerExperience,caseStudiesDetailedCX } from "../../../const/caseStudiesData";

const CaseStudiesPage = () => {
  const { slug } = useParams();
  const allCaseStudies = [
    ...caseStudiesRevenueGrowth,
    ...caseStudiesOperational,
    ...caseStudiesCustomerExperience,
    ...caseStudiesDetailedCX
  ];
  const caseStudy = allCaseStudies.find((study) => study.slug === slug);
  return <CaseStudy data={caseStudy} slug={slug} />;
};

export default CaseStudiesPage;
